export const heroStats = [
  { value: "3 大", label: "漫画体系分类" },
  { value: "10+", label: "常见题材标签" },
  { value: "全彩", label: "彩色上色占比高" },
  { value: "竖屏 / 页漫", label: "两种阅读形态" },
];

export const featureList = [
  {
    icon: "ri-layout-masonry-line",
    title: "按体系分门别类",
    desc: "把韩漫、日漫、国漫拆成三条独立线索，各自的画幅、上色习惯和连载节奏都讲清楚，不用在混杂的列表里翻找。",
  },
  {
    icon: "ri-palette-line",
    title: "全彩与无遮挡说明",
    desc: "标注作品是彩色还是黑白、是完整分格还是竖屏条漫，并对常见版本差异做出中性说明，帮你判断画风是否合口味。",
  },
  {
    icon: "ri-price-tag-3-line",
    title: "题材标签直达",
    desc: "罗曼史、玄幻仙侠、悬疑推理、校园青春等标签直接对应下方作品，点一下即可筛选出同类题材。",
  },
  {
    icon: "ri-book-open-line",
    title: "阅读门槛友好",
    desc: "给出竖屏条漫与页漫的浏览顺序、画质选择、章节衔接等入门建议，新手也能快速进入状态。",
  },
];

export const genreList = [
  {
    id: "hanman",
    key: "韩漫",
    label: "韩漫 · 竖屏全彩",
    tagline: "竖屏滑动、全彩上色、都市情感见长",
    desc: "韩国网络漫画以竖屏条漫为绝对主流，画面自上而下连续推进，一端是单格的氛围铺垫，另一端是拉长的名场面。上色普遍是整幅全彩，配色干净、饱和度高，适合手机端一次滑到底。",
    traits: [
      "画幅：竖屏条漫，单话偏短，多为周更",
      "上色：整幅全彩，光影质感强，背景偏写实造型",
      "题材：都市罗曼史、复仇逆袭、职场、豪门与家族冲突",
      "节奏：冲突发生快，常有明显的钩子收尾",
    ],
    fit: "适合喜欢连贯滑动阅读、看重画面色彩与情绪张力，并偏好现代都市题材的读者。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20vertical%20comic%20panel%20illustration%20of%20a%20modern%20city%20skyline%20at%20dusk%2C%20bold%20flat%20color%20blocks%2C%20warm%20amber%20and%20soft%20coral%20palette%2C%20clean%20geometric%20shapes%2C%20minimal%20cream%20background%2C%20no%20text%2C%20editorial%20poster%20style%2C%20high%20detail%2C%20harmonious%20composition&width=900&height=1200&seq=genre-hanman-01&orientation=portrait",
  },
  {
    id: "riman",
    key: "日漫",
    label: "日漫 · 分格叙事",
    tagline: "分格阅读、线稿为主、世界观庞大",
    desc: "日本漫画延续页漫的分格传统，一页之内用大小不一的格子控制阅读节奏，视线按分镜引导。大量作品以黑白线稿与网点呈现，也有近年增多的全彩版面，适合喜欢逐格品读细节的读者。",
    traits: [
      "画幅：页漫分格，单行本收录，连载密度较高",
      "上色：黑白线稿与网点为主，全彩版面相对少见",
      "题材：少年热血、少女恋爱、青年向悬疑与科幻",
      "节奏：铺垫细腻，长篇世界观与角色成长线完整",
    ],
    fit: "适合习惯逐格阅读、喜欢收藏单行本、看重长篇叙事与角色弧光的读者。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20manga%20comic%20page%20layout%20illustration%20with%20bold%20panel%20frames%20and%20halftone%20texture%2C%20dynamic%20ink%20line%20art%20in%20warm%20sepia%20and%20amber%20tones%2C%20minimal%20cream%20paper%20background%2C%20no%20text%2C%20clean%20editorial%20poster%20style%2C%20classic%20print%20feel%2C%20high%20detail&width=900&height=1200&seq=genre-riman-01&orientation=portrait",
  },
  {
    id: "guoman",
    key: "国漫",
    label: "国漫 · 国风全彩",
    tagline: "条漫与页漫并行、国风题材突出",
    desc: "中国原创漫画同时存在竖屏条漫与页漫两种形态，全彩占比较高。题材上玄幻仙侠、武侠江湖与国风历史非常突出，配色常带水墨与低饱和的东方韵味，近年也涌现出大量都市与科幻新作。",
    traits: [
      "画幅：条漫与页漫并行，视平台与作品而定",
      "上色：全彩为主，常见水墨混色与东方配色",
      "题材：玄幻仙侠、武侠、国风历史、都市异能",
      "节奏：设定宏大的长篇居多，也有短篇单元故事",
    ],
    fit: "适合喜欢东方美学、修仙与江湖设定，想在同一平台兼顾条漫与页漫的读者。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20ink%20wash%20comic%20illustration%20of%20misty%20mountains%20and%20a%20distant%20pavilion%2C%20soft%20jade%20green%20and%20warm%20amber%20paper%20tones%2C%20flowing%20brush%20texture%2C%20minimal%20cream%20background%2C%20no%20text%2C%20elegant%20oriental%20poster%20style%2C%20high%20detail&width=900&height=1200&seq=genre-guoman-01&orientation=portrait",
  },
];

export const colorStyleList = [
  {
    icon: "ri-drop-fill",
    name: "整幅全彩",
    desc: "整幅画面统一上色，光影、材质与背景一并完成，常见于韩漫与多数国漫条漫，观感接近彩色剧集。",
  },
  {
    icon: "ri-contrast-drop-line",
    name: "黑白线稿 + 网点",
    desc: "以墨线与网点表现明暗，靠分镜和构图制造张力，是传统日漫的标志性呈现方式，适合逐格品读线条。",
  },
  {
    icon: "ri-gradienter-line",
    name: "半彩 / 关键页全彩",
    desc: "以黑白为主，在名场面或封面插入全彩页面，用于强化高潮段落，兼顾成本与视觉冲击。",
  },
  {
    icon: "ri-file-shield-2-line",
    name: "版本与完整度差异",
    desc: "同一作品可能存在章节完整度、页序与画面裁切不同的版本，建议优先选择标注清晰、更新有序的来源。",
  },
];

export const themeTags = [
  "全部",
  "罗曼史",
  "都市情感",
  "热血冒险",
  "玄幻仙侠",
  "悬疑推理",
  "校园青春",
  "职场逆袭",
  "治愈日常",
  "奇幻异世界",
  "科幻未来",
];

export const recommendList = [
  {
    title: "霓虹心事",
    origin: "韩漫",
    status: "连载中",
    rating: "9.2",
    tags: ["罗曼史", "都市情感"],
    summary: "都市夜晚里两家相邻店铺的店主，从误会到靠近。全彩条漫，情绪推进细腻，适合睡前一次滑完几话。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20comic%20book%20cover%20illustration%20of%20a%20quiet%20city%20street%20at%20night%20with%20warm%20neon%20signs%2C%20flat%20vector%20shapes%2C%20coral%20and%20amber%20palette%2C%20minimal%20cream%20background%2C%20no%20text%2C%20modern%20editorial%20poster%20style%2C%20high%20detail&width=600&height=800&seq=cover-manga-01&orientation=portrait",
  },
  {
    title: "雾都晚餐",
    origin: "韩漫",
    status: "已完结",
    rating: "8.9",
    tags: ["职场逆袭", "都市情感"],
    summary: "被顶替升职的料理师回到老城区开小馆，用一道道晚餐换回口碑。全彩画风干净，商战与温情交织。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20comic%20book%20cover%20illustration%20of%20a%20cozy%20small%20restaurant%20table%20set%20for%20dinner%2C%20flat%20vector%20shapes%2C%20warm%20amber%20and%20soft%20olive%20palette%2C%20minimal%20cream%20background%2C%20no%20text%2C%20editorial%20poster%20style%2C%20high%20detail&width=600&height=800&seq=cover-manga-02&orientation=portrait",
  },
  {
    title: "银月骑士团",
    origin: "日漫",
    status: "连载中",
    rating: "9.0",
    tags: ["热血冒险", "奇幻异世界"],
    summary: "边境少女加入月下骑士团，从见习一路成长。分格打斗场面张力十足，世界观与团体群像铺展扎实。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20fantasy%20comic%20book%20cover%20illustration%20of%20a%20silver%20moon%20over%20a%20lone%20tower%2C%20bold%20flat%20vector%20shapes%2C%20warm%20sepia%20and%20amber%20palette%2C%20minimal%20cream%20background%2C%20no%20text%2C%20epic%20editorial%20poster%20style%2C%20high%20detail&width=600&height=800&seq=cover-manga-03&orientation=portrait",
  },
  {
    title: "方格之外",
    origin: "日漫",
    status: "已完结",
    rating: "9.3",
    tags: ["悬疑推理", "都市情感"],
    summary: "一桩旧案把三名旧友重新拉回同一张棋盘。黑白线稿加关键页全彩，推理链条严丝合缝，适合一口气读完。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20mystery%20comic%20book%20cover%20illustration%20of%20a%20chessboard%20and%20a%20single%20candle%2C%20bold%20ink%20line%20art%20with%20halftone%2C%20muted%20sepia%20and%20warm%20amber%20palette%2C%20minimal%20cream%20background%2C%20no%20text%2C%20editorial%20poster%20style%2C%20high%20detail&width=600&height=800&seq=cover-manga-04&orientation=portrait",
  },
  {
    title: "山海拾遗录",
    origin: "国漫",
    status: "连载中",
    rating: "9.1",
    tags: ["玄幻仙侠", "奇幻异世界"],
    summary: "少年沿着一卷残破山海图寻访异兽与旧神。全彩国风画面，水墨混色，设定繁复但每话都有新生物登场。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20mythology%20comic%20book%20cover%20illustration%20of%20misty%20peaks%20and%20an%20ancient%20scroll%2C%20ink%20wash%20brush%20texture%2C%20jade%20green%20and%20warm%20amber%20paper%20palette%2C%20minimal%20cream%20background%2C%20no%20text%2C%20elegant%20oriental%20poster%20style&width=600&height=800&seq=cover-manga-05&orientation=portrait",
  },
  {
    title: "长安夜行",
    origin: "国漫",
    status: "连载中",
    rating: "8.8",
    tags: ["悬疑推理", "玄幻仙侠"],
    summary: "长安城新设的夜巡司专办怪谈案件，一名书吏与两名捕快组队查案。国风全彩，案件单元式展开，节奏利落。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20ancient%20Chinese%20city%20comic%20book%20cover%20illustration%20of%20lantern%20lit%20streets%20under%20a%20night%20sky%2C%20ink%20wash%20and%20flat%20color%20mix%2C%20deep%20amber%20and%20jade%20palette%2C%20minimal%20cream%20background%2C%20no%20text%2C%20editorial%20poster%20style&width=600&height=800&seq=cover-manga-06&orientation=portrait",
  },
  {
    title: "第三教学楼",
    origin: "国漫",
    status: "已完结",
    rating: "8.6",
    tags: ["校园青春", "治愈日常"],
    summary: "高三最后一年，一间旧教室里几个人的日常与告别。全彩清爽画风，篇幅不长，收尾干净，适合周末通读。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20school%20life%20comic%20book%20cover%20illustration%20of%20a%20sunlit%20classroom%20with%20open%20windows%2C%20soft%20flat%20vector%20shapes%2C%20warm%20amber%20and%20pale%20olive%20palette%2C%20minimal%20cream%20background%2C%20no%20text%2C%20gentle%20editorial%20poster%20style&width=600&height=800&seq=cover-manga-07&orientation=portrait",
  },
  {
    title: "星轨尽头",
    origin: "日漫",
    status: "连载中",
    rating: "9.0",
    tags: ["科幻未来", "热血冒险"],
    summary: "星际货船上的少年机械师卷入一场航路争夺。分格太空战描写细致，硬核设定与少年成长线并行。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20science%20fiction%20comic%20book%20cover%20illustration%20of%20a%20small%20spaceship%20near%20a%20ringed%20planet%2C%20bold%20flat%20vector%20shapes%2C%20warm%20amber%20and%20soft%20coral%20palette%2C%20minimal%20cream%20background%2C%20no%20text%2C%20editorial%20poster%20style%2C%20high%20detail&width=600&height=800&seq=cover-manga-08&orientation=portrait",
  },
];

export const readingSteps = [
  {
    step: "01",
    title: "先定体系，再定题材",
    desc: "想清楚更习惯竖屏滑动还是逐格翻页，选出韩漫或日漫、国漫其中一条线索，再从题材标签里挑一个方向。",
  },
  {
    step: "02",
    title: "看三话再决定追不追",
    desc: "新作品建议先读前三话，重点感受分镜节奏与上色风格是否合眼缘，再决定是否投入长篇。",
  },
  {
    step: "03",
    title: "留意版本与更新顺序",
    desc: "确认章节目录是否连续、页码是否标注清楚，遇到跳章或重复页优先换一个来源，避免读到断章。",
  },
  {
    step: "04",
    title: "用标签沉淀口味",
    desc: "把喜欢的题材标签记下来，下次直接按标签检索同类新作，比逐条翻榜单效率高得多。",
  },
];

export const faqList = [
  {
    q: "韩漫、日漫、国漫到底该怎么选？",
    a: "可以按阅读习惯来选：喜欢竖屏连续滑动、整幅全彩的选韩漫；习惯分格逐页品读、看重长篇世界观与线条的选日漫；既想要竖屏条漫又想看页漫、偏爱国风与玄幻设定的选国漫。三者并不互斥，很多读者会同时追两到三条线。",
  },
  {
    q: "“全彩”和“无遮挡”这里指的是什么？",
    a: "“全彩”指整幅画面经过完整上色，而非单纯黑白线稿；“无遮挡”在本站用来描述分镜与画面处理的完整度，即内容未经明显裁切或遮盖，阅读体验更连贯。具体作品是否完整，仍以你选择的阅读来源标注为准。",
  },
  {
    q: "为什么同一部作品会有不止一个版本？",
    a: "网络连载、单行本整理、平台再上架等环节可能产生章节划分、页序与画质上的差异，翻译与校对进度也不完全同步。建议优先选择目录清晰、更新有序、标注了章节状态的来源。",
  },
  {
    q: "本站会直接展示或提供漫画正文吗？",
    a: "本站是一份分类指南，用来说明各体系的画幅习惯、上色风格、题材分布与阅读方法，帮助你先定位再到合规渠道阅读。页面不提供正文内容，也不收集你的账号或支付信息。",
  },
  {
    q: "怎么快速找到自己可能喜欢的题材？",
    a: "先在上方的题材标签里点一个方向，下方的精选推荐会即时筛选出同类作品；也可以按韩漫、日漫、国漫三条体系逐个浏览，通常三到五分钟就能锁定几部想试读的。",
  },
];

export const tipsList = [
  {
    icon: "ri-time-line",
    title: "控制单次时长",
    desc: "条漫容易一路下滑，建议每半小时起身活动一次，屏幕亮度与环境光保持接近。",
  },
  {
    icon: "ri-eye-line",
    title: "按设备选画质",
    desc: "手机流量有限时选标准画质，大屏设备再切高清，避免频繁缓冲打断阅读节奏。",
  },
  {
    icon: "ri-list-check-2",
    title: "善用收藏与标签",
    desc: "把在追的作品按题材分类收藏，新章节更新时按类别集中处理，不至于漏更。",
  },
  {
    icon: "ri-lightbulb-line",
    title: "理性看待榜单",
    desc: "榜单反映热度而非个人口味，遇到不合口味的作品直接换一本，不必硬啃。",
  },
];